import React from 'react';
import { ContainedPolygons } from '../../pages/admin_polygons/models/polygonsModel';
import { Alert, Col, Row } from 'reactstrap';

interface Props {
  assigned_polygon?: number | null;
  contained_polygons?: ContainedPolygons[];
}

const AssignedAddressCard = ({
  assigned_polygon = null,
  contained_polygons = [],
}: Props) => {
  if (!contained_polygons || !contained_polygons.length) {
    return <></>;
  }

  return (
    <Row>
      <Col>
        <Alert color="secondary">
          <small className="text-uppercase text-muted d-block mb-1">
            Ubicación asignada
          </small>
          <strong>
            {contained_polygons.map((p, i) => (
              <React.Fragment key={`${p.name}-${i}`}>
                {i > 0 && <span className="mx-2 text-muted">›</span>}
                {p.name}
              </React.Fragment>
            ))}
          </strong>
        </Alert>
      </Col>
    </Row>
  );
};

export default AssignedAddressCard;
